import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
	selector: 'tr[app-component-list-item]',
	templateUrl: './component-list-item.component.html',
	styleUrls: ['./component-list-item.component.scss']
})
export class ComponentListItemComponent implements OnInit {
	@Input() componentData;
	@Input() isAdmin: boolean;
	@Output() output = new EventEmitter();
	@Input() indexNumber: number;
	@Input() isBeeFree;
	showToolbar = false;
	componentType: string;
	disableDuplicate = false;

	constructor() {}

	ngOnInit() {
		const config = JSON.parse(JSON.stringify(this.componentData.config));
		this.componentData.icon = this.componentData.icon ? this.componentData.icon : 'fa fa-exclamation-circle';
		this.componentType = config.desc;
		this.componentData.opens =
			typeof this.componentData.info_widgets_report !== 'undefined' && this.componentData.info_widgets_report
				? this.componentData.info_widgets_report.opens
				: 0;
		this.componentData.clicks =
			typeof this.componentData.info_widgets_report !== 'undefined' && this.componentData.info_widgets_report
				? this.componentData.info_widgets_report.clicks
				: 0;
		this.disableDuplicate = !this.componentData.config.newapi && this.componentData.config.type != 24 && !this.isAdmin;
	}

	deleteComponent(componentId) {
		this.output.emit({ method: 'delete', componentId: componentId });
	}

	sendToBeeFree(componentId) {
		this.output.emit({ method: 'sendToBeeFree', componentId: componentId });
	}
}
